import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ResponsiveContext } from 'grommet';
import { Box, Text, Span, A } from '../../components/element';
import {
  DOC_PATH,
  PRODUCT_ID_ALLETRAB10K,
  PRODUCT_ID_SDS,
} from '../../constants';
import { Feedback } from '../../components/page';
import {
  ProductsList,
  useFetch,
  BackgroundStyle,
  ButtonGridStyle,
} from '../landingPage';
import {
  PRODUCT_ID_NIMBLE,
  PRODUCT_ID_DHCI,
  PRODUCT_ID_PRIMERA,
  PRODUCT_ID_ALLETRA,
  PRODUCT_ID_BAAS,
  PRODUCT_ID_FILE,
  PRODUCT_ID_PCBE,
  PRODUCT_ID_OAAS,
  TAKE_SURVEY_LINK,
} from '../../constants';
import { ChangeQueryString } from '../../utils/withPath';

function LandingPage(props) {
  const { t } = useTranslation();
  // Use 'loading' for spinner or load indicators until XHR is completed
  // eslint-disable-next-line
  const [landingDesc, loading] = useFetch(DOC_PATH + 'welcome-center.json');
  useEffect(() => {
    ChangeQueryString({}, props.location, props.history);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // Each product details are passed as an object to the array, update the object when ProStack details are available
  const productArrayList = [
    {
      id: PRODUCT_ID_ALLETRAB10K,
      value: t('alletraMPB10k'),
    },
    {
      id: PRODUCT_ID_OAAS,
      value: t('oaas'),
    },
    {
      id: PRODUCT_ID_BAAS,
      value: t('baas'),
    },
    {
      id: PRODUCT_ID_SDS,
      value: t('softwareDefinedStorage'),
    },
    {
      id: PRODUCT_ID_PCBE,
      value: t('privateCloudBusinessEdition'),
    },
    {
      id: PRODUCT_ID_FILE,
      value: t('file'),
    },
    {
      id: PRODUCT_ID_ALLETRA,
      value: t('hpeAlletra'),
    },
    {
      id: PRODUCT_ID_PRIMERA,
      value: t('primeraStorage'),
    },
    {
      id: PRODUCT_ID_NIMBLE,
      value: t('nimbleStorageArray'),
    },
    {
      id: PRODUCT_ID_DHCI,
      value: t('nimbleStoragedHCI'),
    },
  ];

  const responsiveOutput = (size) => {
    return size === 'small' ? 'center' : 'start';
  };

  return (
    <ResponsiveContext.Consumer>
      {(size) => (
        <Box
          justify="start"
          style={BackgroundStyle}
          flex={true}
          className="paddingLeft5 paddingRight5 big-desktop"
        >
          {/* Welcome Center title */}
          <Text
            className="marginTop4 marginBottom5 fontSize50 semiBold lineHeightCompact white"
            style={{ textAlign: responsiveOutput(size) }}
            alignSelf={responsiveOutput(size)}
            id="welcomeCenterTitle"
          >
            {t('welcomeCenter')}
          </Text>
          {/* Body */}
          <Box align={responsiveOutput(size)} margin={{ bottom: 'xlarge' }}>
            {/* Landing Description */}
            <Text
              weight="normal"
              className="fontSize18 white"
              id="welcomeCenterDesc"
              style={{ maxWidth: '700px', textAlign: responsiveOutput(size) }}
            >
              {landingDesc}
            </Text>
            {/* Product Selection */}
            <Text
              weight="bold"
              className="fontSize18 white"
              style={{ marginTop: '30px' }}
            >
              {t('productSelection')}
            </Text>
            <div className="product-tem-grid" style={ButtonGridStyle}>
              <ProductsList
                products={productArrayList}
                location={props.location}
                history={props.history}
              />
            </div>
            <div style={{ margin: '50px 0 0 20px' }}>
              <A
                href={TAKE_SURVEY_LINK}
                target="_blank"
                style={{ textDecoration: 'none' }}
              >
                <Text className="surveyLinkTextClass">
                  {t('takeSurvey')}
                  <Span className="surveyLinkClass"></Span>
                </Text>
              </A>
            </div>
          </Box>
          <Feedback responsive={size} />
        </Box>
      )}
    </ResponsiveContext.Consumer>
  );
}

export default LandingPage;
